import * as l from "./links";
import { defaultJiData } from "./default";
import { UnityData } from "../../../LinkDataInterface";
import * as p from "../permanant";

export const hermine: UnityData = {
  ...defaultJiData,
  groups: [
    [
      l.odjPleniaire,
      l.odjAnim,
      l.odjTech,
      l.odjPromo,
      l.odjPres,
      l.listComity,
      p.coordonnesPJ,
    ],
    [
      l.contratASigner,
      l.dossierTresorerie,
      l.encaissementCash,
      l.budget,
      l.suiviPaiements,
      l.justificatifsATraiter,
      l.demandeArgent,
    ],
    [p.bexio, p.ubs, p.tva, p.carteDeCredit, p.twint, p.paiementEnLigne],
    [l.besoinTech, l.deadlineTech, l.planningPublication, l.folderSecurity],
    [l.suiviAnim, l.planningParSalle, p.formulaireAnim, p.contractor],
    [l.suiviActivities, l.folderActivities],
  ],
};

export const event: UnityData = {
  ...defaultJiData,
  groups: [
    [l.listComity, l.planningComite, l.folderDynamic],
    [l.planningParSalle, l.suiviAnim, l.besoinTech],
    [l.encaissementCash, p.bexio, p.ubs, p.carteDeCredit],
    [l.suiviActivities, l.suiviConcert],
  ],
};
